import React from 'react';
import { Box } from 'vindi-ds-components';
import ProductName from '../../components/product_name';
import ProductType from '../../components/product_type';
import ProductInvoice from '../../components/product_invoice';
import Pricing from '../../components/pricing';
import ApiArea from '../../components/api_area';
import CustomFields from '../../components/custom_fields';

function FormFields() {
  return (
    <Box display='flex' flexDirection='column' margin='2em 0 1.5em 0' css={{ gap: '0.5em' }}>
      <ProductName />
      <ProductType />
      <ProductInvoice />
      <Pricing />
      <ApiArea />
      <CustomFields />
    </Box>
  );
}

export default FormFields;
